import { useState } from "react";
import {
  MiBox,
  MiBuildPageHeader,
  MiButton,
  MiIcon,
  MiList,
  MiMenu,
  MiModalConfirm,
} from "@miplatform/components";
import {
  BUTTON_COLORS,
  BUTTON_LABELS,
  BUTTON_VARIANTS,
  ICONS_WEB,
  MODAL_TITLES,
  PAGINATION,
} from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import * as mdi from "@mdi/js";
import { Box, useTheme } from "@mui/material";
import { useAddersViewModel } from "./useAddersViewModel";

export function Adders() {
  const [selectedAdder, setSelectedAdder] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const { navigate } = useRouter();
  const theme = useTheme();
  const {
    adders,
    refresh,
    getAdders,
    handleSetData,
    handleDeleteAdder,
    recentAdders,
    setRecentAdders,
    getRecentAdders,
    isLoading,
  } = useAddersViewModel();

  const sections = [
    {
      fieldset: [
        {
          label: "Name",
          field: "name",
          color: theme.palette.primary.main,
        },
      ],
    },
  ];

  const handleNavigate = (id, viewOnly) => {
    navigate(`/estimating/configuration/adders/${id}`, { state: { viewOnly } });
  };

  const renderItemActions = (item) => (
    <Box onClick={(e) => e.stopPropagation()}>
      <MiMenu
        data={[
          {
            label: BUTTON_LABELS.EDIT,
            icon: mdi[ICONS_WEB.PENCIL_OUTLINE],
            action: () => handleNavigate(item.id, false),
          },
          {
            label: BUTTON_LABELS.DELETE,
            icon: mdi[ICONS_WEB.TRASH_CAN],
            action: () => handleOpenDeleteModal(item),
            color: theme.palette.red.main,
          },
        ]}
      />
    </Box>
  );

  const handleOpenDeleteModal = (item) => {
    setSelectedAdder(item);
    setOpenDeleteModal(true);
  };

  const handleConfirmDeleteModal = () => {
    handleDeleteAdder(selectedAdder);
    setOpenDeleteModal(false);
  };

  return (
    <>
      <MiBuildPageHeader
        title="Adders"
        loading={isLoading}
        titleIcon={
          <MiIcon
            path={mdi[ICONS_WEB.HEXAGON_OUTLINE]}
            color={theme.palette.primary.main}
          />
        }
        actionComponent={
          <MiButton
            title="Adder"
            variant={BUTTON_VARIANTS.CONTAINED}
            startIcon={{ path: mdi[ICONS_WEB.PLUS] }}
            onClick={() =>
              navigate("/estimating/configuration/add-adders", {
                state: { viewOnly: false },
              })
            }
            data-testid="add-adder-btn"
          />
        }
        actionContainerStyle={{
          flexWrap: "nowrap",
        }}
      />
      <MiBox>
        <MiList
          viewType="card"
          showRecent
          cardProps={{
            sections,
            renderItemActions,
            onClick: (item) => handleNavigate(item.id, true),
            leftCardProps: { fieldset: [] },
          }}
          loading={isLoading}
          data={adders}
          setData={handleSetData}
          dataProvider={getAdders}
          recentData={recentAdders}
          setRecentData={setRecentAdders}
          recentDataProvider={getRecentAdders}
          refresh={refresh}
          paginationMode={PAGINATION.SERVER}
          emptyListProps={{
            text: "No Adders found",
          }}
          data-testid="adders-list"
        />
        <MiModalConfirm
          title={MODAL_TITLES.DELETE}
          open={openDeleteModal}
          textPositive={BUTTON_LABELS.DELETE}
          buttonPositiveColor={BUTTON_COLORS.RED}
          titleIcon={{
            path: mdi[ICONS_WEB.TRASH_CAN],
            color: theme.palette.red.main,
          }}
          handleNegative={() => setOpenDeleteModal(false)}
          handlePositive={handleConfirmDeleteModal}
          description={`You are about to delete ${selectedAdder?.name}. Are you sure you would like to continue?`}
        />
      </MiBox>
    </>
  );
}
